import React, { useState, useEffect, useRef, useContext } from 'react';
import { Box, Typography, Paper, useTheme, useMediaQuery, Chip } from '@material-ui/core';
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';

import { Store } from '../Store';
import axios from "axios";
import config, { getParameterByName, merchantCode } from "../util";

const containerStyle = {
  width: '100%',
  height: '350px',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  border: '1px solid #e0e0e0'
};

export default function TrackingScreen(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { state } = useContext(Store);
  const [order, setOrder] = useState(null);
  const isPickupOrder = order?.orderType === 'Pick Up';

  const [status, setStatus] = useState('Preparing');
  const [driverPosition, setDriverPosition] = useState({ lat: 13.0, lng: 77.0 });
  const [animationProgress, setAnimationProgress] = useState(0);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [estimatedTime, setEstimatedTime] = useState(30);
  const animationRef = useRef(null);
  const tempOrderId = getParameterByName('ord_id');
  const [ordId, setOrdId] = useState("");
  const merchantCode = getParameterByName('merchantCode');

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY // set your API key in .env
  });

  useEffect(() => {
    axios.get(`${config.baseURL}/api/temporders/${tempOrderId}?merchantCode=${merchantCode}`).then((res) => {
      setOrdId(res.data.orderId);
    });
  }, []);

  const normalizeCoordinates = (coords) => {
    if (!Array.isArray(coords) || coords.length < 2) {
      return { lat: 13.0827, lng: 80.2707 }; // Chennai default
    }
    // If first value is longitude, swap
    if (Math.abs(coords[0]) > Math.abs(coords[1])) {
      return { lat: coords[1], lng: coords[0] };
    }
    return { lat: coords[0], lng: coords[1] };
  };

  const getOrderDetails = (ordId) => {
    if (ordId) {
      axios.get(`${config.baseURL}/api/orders/${ordId}`).then((res) => {
        if (res.data) {
          setOrder(res.data);
          if(res.data.orderStatus.toUpperCase() == 'DELIVERED' ){
            props.history.push("/?" + window.location.href.split("?")[1]);
          }
          setDriverPosition(normalizeCoordinates(res.data.driverDetails?.currentLocation?.coordinates));
        }
      });
    }
  };

  useEffect(() => {
    const startAnimation = () => {
      getOrderDetails(ordId);
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
      const updateInterval = 30000;
      animationRef.current = setInterval(() => {
        getOrderDetails(ordId);
      }, updateInterval);
    };

    const timer = setTimeout(() => {
      setStatus('On the way');
      startAnimation();
    }, 3000);

    return () => {
      clearTimeout(timer);
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
    };
  }, [ordId]);

  useEffect(() => {
    if (animationProgress === 1) {
      setStatus('Delivered');
    } else if (animationProgress > 0) {
      setStatus('On the way');
    }
  }, [animationProgress]);

  const getStatusColor = () => {
    switch (status) {
      case 'Preparing': return '#f57c00';
      case 'On the way': return '#f57c00';
      case 'Delivered': return '#388e3c';
      default: return '#757575';
    }
  };

  const formatLastUpdated = () => {
    if (!lastUpdated) return "Not yet updated";
    return lastUpdated.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <Box style={{ padding: '2px' }}>
      <Paper
        elevation={2}
        style={{ borderRadius: '1px', overflow: 'hidden', marginBottom: '20px' }}
      >
        <Box
          style={{
            backgroundColor: getStatusColor(),
            padding: '1px',
            color: 'white',
          }}
        >
          <Typography
            variant={isSmallScreen ? 'h5' : 'h4'}
            style={{ fontWeight: 500 }}
          >
            {isPickupOrder ? 'Order Status' : 'Order Tracking'}
          </Typography>
        </Box>

      
          <Box
            display="flex"
            flexDirection={isSmallScreen ? 'column' : 'row'}
            justifyContent="space-between"
            alignItems={isSmallScreen ? 'flex-start' : 'center'}
            mb={2}
          >
           
              <Chip
                label={isPickupOrder ? 'Ready for Pickup' : status}
                style={{
                  backgroundColor: getStatusColor(),
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  margin: '5px',
                  padding:"2px",
                  borderRadius:"6px"
                }}
              />
        
           
      

          {/* Map only for delivery orders */}
          {!isPickupOrder && order && driverPosition && isLoaded && (
            <Box
              style={{
                ...containerStyle,
                height: isSmallScreen ? '290px' : '350px',
              }}
            >
              <GoogleMap
                mapContainerStyle={{ width: '100%', height: '100%', borderRadius: '8px' }}
                center={driverPosition}
                zoom={14}
              >
                <Marker
  position={driverPosition}
  icon={{
    url: "https://pub-63627581b4dc4babba33eaf78a5e6e5b.r2.dev/users-media/delivery-drive.png", // example bike icon
    scaledSize: new window.google.maps.Size(40, 40), // resize
    anchor: new window.google.maps.Point(20, 20) // center the icon
  }}
/>

                <InfoWindow position={driverPosition}>
                  <div>
                    <strong>Driver</strong>
                    <br />
                    Your delivery is on the way!
                  </div>
                </InfoWindow>
              </GoogleMap>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
